<template>
	<div class="pr_english">
		<div class="pc_box" v-if="!isPhone">
			<div class="pd_list flex3">
				<div class="pd_item flex1" v-for="(item,index) in prolist2" :key="index">
					<div class="pdm_left">
						<img :src="staticImg+item.image">
					</div>
					<div class="pdm_right">
						<p class="prt_p1">{{ item.name }}</p>
						<p class="prt_p2">{{ item.description }}</p>
						<img @click="toProductDetail(item.id)" src="@/images/productCenter/eng/more.png">
					</div>
				</div>
			</div>
		</div>
		<div class="ph_box" v-if="isPhone">
			<enHeader2 :searchShow="true" pageTitle="Product"></enHeader2>
			<div class="pd_list">
				<div class="pd_item" v-for="(item,index) in prolist2" :key="index">
					<div class="pdm_left" data-aos="fade-up">
						<img :src="staticImg+item.image">
					</div>
					<div class="pdm_right" data-aos="fade-up">
						<p class="prt_p1">{{ item.name }}</p>
						<p class="prt_p2">{{ item.description }}</p>
						<img @click="toProductDetail(item.id)" src="@/images/productCenter/eng/more.png">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPhone: this.$isMobile,
			staticImg: this.$staticImg,
			prolist2: [],
		};
	},
	created() {
		this.productxl();
	},
	methods: {
		// 商品列表，英文只有5款商品
		async productxl() {
			const res = await this.$api.enProductlist({
				product_id: '',
			});
			if (res.code == 1) {
				this.prolist2 = res.data;
			}
		},
		toProductDetail(id) {
			this.$router.push("/en/productDetail?gid=" + id);
		},
	},
}
</script>

<style lang="scss">
@function vw($size) {
	@return $size/1920 * 100vw;
}
.pr_english {
    @font-face {
		font-family: "SourceHanSerifCN";
		src: url("../../font/SourceHanSerifCN-Heavy.otf");
	}
	font-family: "SourceHanSerifCN";
	.pc_box {
		margin-top: 80px;
		min-width: 1000px;
		.pd_list {
			flex-wrap: wrap;
			.pd_item {
				width: 50%;
				height: vw(600);
				padding: vw(145) vw(105) vw(120) vw(50);
				box-sizing: border-box;
				background-size: 100% 100%;
				background-repeat: no-repeat;
				&:nth-child(1) {
					background-image: url("../../images/productCenter/eng/bg1.png");
				}
				&:nth-child(2) {
					background-image: url("../../images/productCenter/eng/bg2.png");
				}
				&:nth-child(3) {
					background-image: url("../../images/productCenter/eng/bg3.png");
				}
				&:nth-child(4) {
					background-image: url("../../images/productCenter/eng/bg4.png");
				}
				&:nth-child(5) {
					width: 100%;
					background-image: url("../../images/productCenter/eng/bg5.png");
				}
				.pdm_left {
					width: vw(360);
					img {
						width: vw(360);
						height: auto;
                        transition: transform 0.5s ease;
                        cursor: pointer;
						&:hover {
							transform: scale(1.07);
						}
					}
				}
				.pdm_right {
					flex: 1;
					margin-left: 15px;
					text-align: left;
					.prt_p1 {
						font-size: vw(40);
						font-weight: bold;
					}
					.prt_p2 {
						font-size: 14px;
						margin-top: vw(55);
						line-height: 2;
						cursor: pointer;
						&:hover {
							color: #d43235;
						}
					}
					img {
						width: vw(90);
						margin-top: vw(50);
						cursor: pointer;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1600px) {
		.pc_box {
			.pd_list {
				.pd_item {
					padding: vw(100) vw(80) vw(100) vw(50);
					.pdm_left {
						width: vw(360);
						img {
							width: vw(360);
							height: vw(360);
						}
					}
					.pdm_right {
						flex: 1;
						margin-left: 15px;
						text-align: left;
						.prt_p1 {
							font-size: vw(30);
							font-weight: bold;
						}
						.prt_p2 {
							font-size: 14px;
							margin-top: vw(30);
							line-height: 2;
						}
						img {
							width: vw(100);
							margin-top: vw(30);
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1300px) {
		.pc_box {
			.pd_list {
				.pd_item {
					padding: vw(80) vw(50) vw(80) vw(40);
					.pdm_left {
						width: vw(300);
						img {
							width: vw(300);
							height: vw(300);
						}
					}
					.pdm_right {
						flex: 1;
						margin-left: 15px;
						text-align: left;
						.prt_p1 {
							font-size: vw(30);
							font-weight: bold;
						}
						.prt_p2 {
							font-size: 14px;
							margin-top: vw(18);
							line-height: 1.8;
						}
						img {
							width: vw(100);
							margin-top: vw(20);
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.pc_box {
			.pd_list {
				.pd_item {
					padding: 40px 30px;
					height: 313px;
					.pdm_left {
						width: 150px;
						img {
							width: 150px;
							height: 150px;
						}
					}
					.pdm_right {
						flex: 1;
						margin-left: 10px;
						text-align: left;
						.prt_p1 {
							font-size: 18px;
							font-weight: bold;
						}
						.prt_p2 {
							font-size: 14px;
							margin-top: 15px;
							line-height: 1.5;
						}
						img {
							width: 60px;
							margin-top: 15px;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	.ph_box {
		padding-top: 1.23rem;
		.pd_list {
			.pd_item {
				padding: 0.9rem;
				box-sizing: border-box;
				background-size: 100% 100%;
				background-repeat: no-repeat;
				&:nth-child(1) {
					background-image: url("../../images/productCenter/eng/bg6.png");
					background-color: #edecec;
				}
				&:nth-child(2) {
					background-image: url("../../images/productCenter/eng/bg7.png");
					background-color: #f4f4f4;
				}
				&:nth-child(3) {
					background-image: url("../../images/productCenter/eng/bg8.png");
					background-color: #e5e4e4;
				}
				&:nth-child(4) {
					background-image: url("../../images/productCenter/eng/bg9.png");
					background-color: #f4f4f4;
				}
				&:nth-child(5) {
					width: 100%;
					background-image: url("../../images/productCenter/eng/bg10.png");
					background-color: #e5e4e4;
				}
				.pdm_left {
					width: 100%;
					img {
						width: 100%;
					}
				}
				.pdm_right {
					margin-top: 0.5rem;
					.prt_p1 {
						font-size: 0.73rem;
						font-weight: bold;
						text-align: center;
					}
					.prt_p2 {
						font-size: 0.34rem;
						margin: 0.73rem 0;
						line-height: 2;
						text-align: left;
					}
					img {
						width: 2.2rem;
						margin: 0 auto;
					}
				}
			}
		}
	}
}
</style>